import { BaseMenuList, Typography } from '@lyearn/ui';

import SortMenuItem from '../SortMenuItem';
import { BaseSortMenuItem, SortMenuItemsProps } from './types';

const SortMenuItemsDesktop = <T extends BaseSortMenuItem>(props: SortMenuItemsProps<T>) => {
  const { items, label, value, onAction } = props;

  return (
    <BaseMenuList className="space-y-2 p-8">
      {label ? (
        <Typography as="p" className="p-12 pb-4" color="text-text-placeholder" variant="label-caps">
          {label}
        </Typography>
      ) : null}
      {items.map((item) => (
        <SortMenuItem
          key={item.id}
          isSelected={item.id === value}
          item={item}
          onAction={onAction}
        />
      ))}
    </BaseMenuList>
  );
};

export default SortMenuItemsDesktop;
